import { render, staticRenderFns } from "./data-time.vue?vue&type=template&id=0f05796c&"
import script from "./data-time.vue?vue&type=script&lang=js&"
export * from "./data-time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports